export { default } from './media-content'
